import { render, staticRenderFns } from "./top.vue?vue&type=template&id=55d98610&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=55d98610&prod&lang=scss"
import style1 from "./top.vue?vue&type=style&index=1&id=55d98610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d98610",
  null
  
)

export default component.exports